import { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { buildFilterOptions, buildGetOpportunitiesVariables, getDifferentiatedOpportunities } from "./helpers";
import { GetOpportunities } from "./queries";

export function useOpportunities({ filters, onShareOpportunity }) {
  const { loading, data, refetch } = useQuery(
    GetOpportunities,
    buildGetOpportunitiesVariables({ filters })
  );

  const rawOpportunities = (data && data.opportunities) ? data.opportunities : [];

  const {
    activeOpportunities,
    inactiveOpportunities
  } = getDifferentiatedOpportunities({ rawOpportunities, onShareOpportunity });

  return {
    loading,
    refetchOpportunities: refetch,
    activeOpportunities,
    inactiveOpportunities
  }
}



export function useFilters() {
  const [filters, setFilters] = useState({});
  const { data, loading } = useQuery(GetOpportunities);
  const filterOptions = buildFilterOptions({
    opportunities: (data && data.opportunities) ? data.opportunities : []
  });
  return { filterOptions, filters, setFilters, loading };
}
